<template>
  <div>
    <b-modal
      id="modal-add-other-files"
      ref="modal-add-other-files"
      centered
      :title="$t('DEBTIA_ADD_FILES')"
      :ok-title="$t('DEBTIA_UPLOAD')"
      :no-close-on-backdrop="true"
      cancel-variant="outline-secondary"
      size="lg"
      @ok="submitHandler"
    >
      <b-tabs
        content-class="mt-2"
        justified
        class="addFilesTabs"
      >
        <b-tab
          active
          :title="$t('DEBTIA_OTHER_FILES')"
        >
          <add-other-files-modal
            ref="add-other-files-modal-ref"
            :case-id="caseId"
            :file-saved="fileSaved"
          />
        </b-tab>
        <b-tab
          :title="$t('DEBTIA_BASE_DOCUMENT')"
        >
          <add-base-documents-modal
            ref="add-base-documents-modal-ref"
            :case-id="caseId"
            :file-saved="fileSaved"
          />
        </b-tab>
      </b-tabs>
    </b-modal>
  </div>
</template>

<script>
import {
  BTabs, BTab,
  // BFormInvalidFeedback,
  // BFormDatepicker,
  // BFormCheckbox,
} from 'bootstrap-vue'
// import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import AddOtherFilesModal from './AddOtherFilesModal.vue'
import AddBaseDocumentsModal from './AddBaseDocumentsModal.vue'
// import { ValidationProvider, ValidationObserver } from 'vee-validate'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import constants from '@/app-configs/constants'

export default {
  components: {
    // BFormInvalidFeedback,
    BTabs,
    BTab,
    AddOtherFilesModal,
    AddBaseDocumentsModal,
    // BFormInput,
    // vSelect,
    // ValidationProvider,
    // ValidationObserver,
    // BFormDatepicker,
    // BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  props: {
    caseId: {
      type: [Number, String],
      required: true,
    },
    getDetails: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      fileloader: false,
    }
  },
  watch: {
  },
  created() {
    // this.getReasons()
  },
  methods: {
    submitHandler(bvModalEvt) {
      bvModalEvt.preventDefault()
      const firstDiv = document.querySelector('.addFilesTabs')

      // Select the 'a' element from the 'first' div
      const anchorElement = firstDiv.querySelector('a')
      const hasActiveClass = anchorElement.classList.contains('active')
      if (hasActiveClass) {
        this.$refs['add-other-files-modal-ref'].submitHandler()
      } else {
        this.$refs['add-base-documents-modal-ref'].submitHandler()
      }
    },
    fileSaved() {
      this.$refs['modal-add-other-files'].hide()
      this.getDetails()
    },
  },
  // mounted() {
  //   this.showModal()
  // },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
